import { Heart } from 'lucide-react'

interface FooterProps {
  version?: string
}

export function Footer({ version = '1.0.0' }: FooterProps) {
  return (
    <footer className="border-t bg-canvas-parchment/80 backdrop-blur-sm">
      <div className="container py-6">
        <div className="flex flex-col items-center gap-3">
          {/* Logo and Brand */}
          <div className="flex items-center gap-2">
            <img src="/favicon.svg" alt="" className="w-5 h-5" />
            <span className="text-sm font-semibold text-foreground">PinDD</span>
          </div>

          {/* Crafted By */}
          <p className="text-sm text-muted-foreground flex items-center gap-1.5">
            Crafted with
            <Heart className="h-3.5 w-3.5 fill-red-500 text-red-500" />
            by
            <span
              className="font-medium text-foreground"
              style={{
                fontFamily: "'Georgia', 'Palatino Linotype', 'Book Antiqua', serif",
                fontStyle: 'italic',
                letterSpacing: '0.5px',
              }}
            >
              Alidawang
            </span>
          </p>

          {/* Version */}
          <p
            className="text-xs text-muted-foreground/60"
            style={{
              fontFamily: "'SF Mono', 'Monaco', 'Consolas', monospace",
              letterSpacing: '0.1em',
            }}
          >
            v{version}
          </p>
        </div>
      </div>
    </footer>
  )
}
